import React, { useState } from 'react';

const InterestsCarousel = ({ containers }) => {
    const [temp, setTemp] = useState(0);

    const handlePageUp = () => {
        setTemp((prevState) => {setTemp(prevState+1)});
    }

    const handlePageDown = () => {
        setTemp((prevState) => {setTemp(prevState-1)});
    }

    return (
        <div style={{ display: 'flex' }}>
            {temp >= 1 ? <button onClick={handlePageDown}>back</button> : null}
            {containers[temp]}
            {temp <= 1 ? <button onClick={handlePageUp}>next</button> : null}
        </div>
    );
};

export default InterestsCarousel;